import React from "react";
import "./ImageBanner.css";

/**
 * A supplied banner image, full width. The artwork carries its own title, so
 * `heading` (when given) is kept for screen readers and search only.
 *
 * On desktop the banner is held to the Training banner's height (31.25vw with
 * a 29rem floor) and the image fills it edge to edge, anchored to its top:
 * anything that does not fit is cut from the bottom only — per the user's
 * instruction (2026-09-27). On tablet and mobile it shows at natural height.
 *
 * @param {string} src     path under public/, spaces and "&" allowed
 * @param {string} alt     what the banner says / shows
 * @param {number} width   intrinsic width, reserves the space before load
 * @param {number} height  intrinsic height
 * @param {string} [heading] the page's H1, when the banner replaces the block
 *                           that used to carry it
 * @param {boolean} [whole] show the whole image at its natural height on
 *                           every screen, never cropped (Sustainability & ESG)
 */
const ImageBanner = ({ src, alt, width, height, heading, whole = false }) => (
  <section
    className={`image-banner ${whole ? "image-banner--whole" : ""}`}
    aria-label={alt}
  >
    {heading && <h1 className="sr-only">{heading}</h1>}
    <img
      src={encodeURI(src)}
      alt={alt}
      width={width}
      height={height}
      fetchpriority="high"
      className="image-banner__img"
    />
  </section>
);

export default ImageBanner;
